/**
 * Отметки «просмотрено» для детекций.
 *
 * Хранятся локально в браузере и используются и на дашборде, и в
 * колокольчике уведомлений — поэтому вынесены в общий модуль, чтобы
 * оба места работали с одним и тем же ключом.
 */

const VIEWED_LOGS_KEY = 'flypix:viewed-log-ids';
const LEGACY_VIEWED_LOGS_KEY = 'avivion:viewed-log-ids';

/** Событие, по которому подписчики перечитывают отметки. */
export const VIEWED_LOGS_CHANGED_EVENT = 'flypix:viewed-logs-changed';

export function getViewedLogIds(): Set<number> {
  try {
    // Разовый перенос отметок «просмотрено» со старого ключа бренда
    let raw = localStorage.getItem(VIEWED_LOGS_KEY);
    if (!raw) {
      const legacy = localStorage.getItem(LEGACY_VIEWED_LOGS_KEY);
      if (legacy) {
        localStorage.setItem(VIEWED_LOGS_KEY, legacy);
        localStorage.removeItem(LEGACY_VIEWED_LOGS_KEY);
        raw = legacy;
      }
    }
    if (!raw) return new Set();
    const parsed = JSON.parse(raw) as number[];
    return new Set(Array.isArray(parsed) ? parsed : []);
  } catch {
    return new Set();
  }
}

function persist(ids: Set<number>): void {
  try {
    localStorage.setItem(VIEWED_LOGS_KEY, JSON.stringify(Array.from(ids)));
  } catch {
    /* приватный режим или переполненное хранилище — отметка просто не сохранится */
  }
  window.dispatchEvent(new CustomEvent(VIEWED_LOGS_CHANGED_EVENT));
}

export function markLogViewed(id: number): void {
  const viewed = getViewedLogIds();
  if (viewed.has(id)) return;
  viewed.add(id);
  persist(viewed);
}

export function markLogsViewed(ids: number[]): void {
  const viewed = getViewedLogIds();
  const before = viewed.size;
  ids.forEach((id) => viewed.add(id));
  if (viewed.size === before) return;
  persist(viewed);
}
